import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  Space,
  Input,
  Form,
  Select,
  Typography,
  Table,
  Modal,
  DatePicker,
  Breadcrumb,
  message,
  Tabs,
  InputNumber,
  Empty,
} from "antd";
import {
  DoubleRightOutlined,
  PaperClipOutlined,
  EditFilled,
  PhoneOutlined,
  MailOutlined,
  EyeFilled,
  DownloadOutlined,
  MessageFilled,
  CheckOutlined,
  ExclamationOutlined,
  FileFilled,
  CheckCircleOutlined,
  CloseCircleOutlined,
  DollarOutlined,
  CreditCardOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import {
  GetClientByIdApi,
  GetPartnerClientByIdApi,
  GetClientsByPartnerClientId,
  GetWorkOrderByIdApi,
} from "../../Clients/ClientsApi";
import { useForm } from "antd/es/form/Form";
import { render } from "@testing-library/react";
import { FormattedMessage, useIntl } from "react-intl";
import RecordPayment from "./RecordPayment";
import {
  getAddressCountriesAPI,
  getAddressProvincesAPI,
  getCompanyListAPI,
  getSalesTaxAPI,
} from "CommonComponents/Lookup/LookupAPI";
import FormItem from "antd/es/form/FormItem";
import {
  generateInvoiceAPI,
  GetAdditionalitemsWorkOrderApi,
  GetInvoiceByIdApi,
  GetInvoicePaymentsByInvoiceIdApi,
  invoicePdfAPI,
  previewInvoiceAPI,
  sendInvoiceEmailAPI,
} from "../InvoicesAPI";
import { use } from "react";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import ViewInvoice from "./ViewInvoice";
import SendEmailModal from "features/Clients/Quotes/SendEmailModal";
function CreateInvoice() {
  const { TextArea } = Input;
  const { Option } = Select;
  const { Text } = Typography;
  const dispatch = useDispatch();
  const { Column } = Table;
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const isViewInvoice = location.pathname.includes("viewinvoice");
  const isAdditionalInvoice = location.pathname.includes(
    "generateadditionalinvoice"
  );
  const [form] = Form.useForm();
  const [formInitialvalues, setFormInitialvalues] = useState();
  const { clientId, partnerId, workOrderId, invoiceId, projectId } =
    useParams();
  const companyId = localStorage.getItem("CompanyId");
  const selectedLanguage = localStorage.getItem("selectedlanguage") || "fr-FR";
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isPaymentRecordModelOpen, setIsPaymentRecordModelOpen] =
    useState(false);
  const companyName = useSelector((state) => state.lookup.companies);
  const [isRecordPaymentModalVisible, setIsRecordPaymentModalVisible] =
    useState(false);
  const [isRefundModalVisible, setIsRefundModalVisible] = useState(false);
  const [isRefundProcessing, setIsRefundProcessing] = useState(false);
  const [invoiceDetails, setInvoiceDetails] = useState();
  const [activeTab, setActiveTab] = useState("1");
  const [refundForm] = Form.useForm();
  const workOrderDetails = useSelector(
    (state) => state.clients.workOrderDetails
  );
  const invoiceData = useSelector((state) => state.invoices.invoiceDetails);
  const taxList = useSelector((state) => state.lookup.salesTaxList);
  const totalAmount = workOrderDetails?.grandTotal || 0;
  const totalPaid = workOrderDetails?.totalPaidAmount || 0;
  const dueAmount = totalAmount - totalPaid;
  const [discount, setDiscount] = useState(0);
  const [discountType, setDiscountType] = useState(1);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);
  const [finalInvAmount, setFinalInvAmount] = useState(0);
  const [productsList, setProductsList] = useState([]);
  const invoicePayments = useSelector(
    (state) => state.invoices.invoicePayments
  );
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [emailForm] = useForm();
  const [generatedInvoiceId, setGeneratedInvoiceId] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const additionalItemWorkOrderDetails = useSelector(
    (state) => state.invoices.additionalItemWorkOrderDetails
  );
  const [isAdditionalItem, setAdditionalItem] = useState(false);
  const showRecordPaymentModal = () => {
    setIsRecordPaymentModalVisible(true);
    form.setFieldsValue({
      outstanding: 129.35,
      amountReceived: 129.35,
      discount: 0.0,
      newOutstanding: 0.0,
      paymentDate: null,
    });
  };

  const handleRecordPaymentOk = () => {
    form.validateFields().then((values) => {
      console.log("Payment Data:", values);
      setIsRecordPaymentModalVisible(false);
    });
  };

  const handleRecordPaymentCancel = () => {
    setIsRecordPaymentModalVisible(false);
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const openRefundModal = () => {
    setIsRefundModalVisible(true);
  };

  const closeRefundModal = () => {
    refundForm.resetFields();
    setIsRefundModalVisible(false);
  };

  const handleRefundSubmit = async () => {
    try {
      const values = await refundForm.validateFields();
      setIsRefundProcessing(true);

      // Simulate processing
      setTimeout(() => {
        message.success(`Refund of $${values.amount} processed successfully`);
        setIsRefundProcessing(false);
        closeRefundModal();
      }, 1000);
    } catch (error) {
      console.error("Refund validation failed:", error);
    }
  };
  const addressProvinces = useSelector(
    (state) => state.lookup.addressProvinces
  );
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => setExpanded((prev) => !prev);
  const addressCountries = useSelector(
    (state) => state.lookup.addressCountries
  );
  const isQuillContentEmpty = (html) => {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent.trim() === "";
  };
  const columns1 = [
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },

    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount, record) => {
        let color = "black"; // default
        if (record.type === "Refund") color = "red";
        else if (record.type === "Payment Received") color = "green";
        else if (record.type === "Deposit") color = "blue";

        return <span style={{ color }}>{amount}</span>;
      },
    },
  ];

  const columns2 = [
    {
      title: <FormattedMessage id="ClientDetails.Date" />,
      dataIndex: "date",
      key: "date",
    },
    {
      title: <FormattedMessage id="Lookup.Type" />,
      dataIndex: "type",
      key: "type",
    },
    {
      title: <FormattedMessage id="AddProject.Reference" />,
      dataIndex: "reference",
      key: "reference",
      render: (text) => <p>{text}</p>,
    },
    {
      title: <FormattedMessage id="ClientDetails.Amount" />,
      dataIndex: "amount",
      key: "amount",
      render: (amount, record) => {
        let color = "black"; // default
        if (record.type === "Refund") color = "red";
        else if (record.type === "Payment Received") color = "green";
        else if (record.type === "Deposit") color = "blue";

        return <span style={{ color }}>{amount}</span>;
      },
    },
    // {
    //   title: "Discount",
    //   dataIndex: "discount",
    //   key: "discount",
    // },
    // {
    //   title: "Refund",
    //   dataIndex: "refund",
    //   key: "refund",
    //   render: (refund) => <span style={{ color: "red" }}>{refund}</span>,
    // },
    {
      title: <FormattedMessage id="AddEstimate.Notes" />,
      dataIndex: "refundnotes",
      key: "refundnotes",
    },
  ];

  // Payment type mapping
  const paymentTypeMap = {
    1: "Payment Received",
    2: "Refund",
    3: "Deposit",
  };
  const paymentsArray = invoicePayments?.item1 || [];
  const data1 = paymentsArray?.map((payment, index) => ({
    key: payment.id || index,
    date: new Date(payment.paymentDate).toISOString().split("T")[0],
    type: paymentTypeMap[payment.paymentTypeId] || "Unknown",
    amount: `$${payment.amountReceived.toFixed(2)}`,
  }));
  const InvoicePaymentsTotal = invoicePayments?.item2 || 0;

  const selectedCompany = companyName?.items?.find(
    (company) => company?.id === parseInt(companyId)
  );
  const [selected, setSelected] = useState("Paid");
  const statusMap = {
    Unpaid: { color: "#FC0027", label: "Unpaid" }, // Red
    Paid: { color: "#5CB85C", label: "Paid" }, // Green
  };
  const items1 = Object.keys(statusMap).map((statusKey, index) => ({
    key: String(index),
    label: (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          setSelected(statusKey);
        }}
      >
        {statusKey}
      </a>
    ),
  }));
  const input = {
    pageNo: null,
    pageSize: null,
    searchQuery: "",
  };

  const renderAddress = (addr) => {
    if (!addr) return "";
    const province = addressProvinces.find((p) => p.id === addr.provinceId);
    const country = addressCountries.find((c) => c.id === addr.countryId);

    const provinceName =
      selectedLanguage == "fr-FR"
        ? province?.provinceNameFr
        : province?.provinceNameEn;
    const countryName =
      selectedLanguage == "fr-FR"
        ? country?.countryNameFr
        : country?.countryNameEn;

    const parts = [
      addr?.address1,
      addr?.address2,
      addr?.city,
      invoiceId ? invoiceDetails?.p : provinceName,
      countryName,
      addr?.zip,
    ].filter(Boolean);

    const line1 = [addr?.address1, addr?.address2, addr?.city]
      .filter(Boolean)
      .join(", ");
    const line2 = [provinceName, countryName, addr?.zip]
      .filter(Boolean)
      .join(", ");

    return (
      <>
        {line1}
        <br />
        {line2}
      </>
    );
  };

  // Inside your component
  // Inside your component
  const getDiscountAmount = () => {
    const invoicingAmount = Number(form.getFieldValue("invoiceAmount") || 0);
    const amount = discount || 0;

    if (discountType === 1) {
      // percentage discount
      const invAmount = (amount / 100) * invoicingAmount;
      setFinalInvAmount(invAmount);
      return invAmount;
    } else {
      // fixed discount
      setFinalInvAmount(amount);
      return amount; // do not cap
    }
  };

  const totalColumns = [
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text, record) => {
        if (isViewInvoice) {
          if (["1", "3", "4", "5", "6", "7"].includes(record.key)) {
            return {
              children: text,
              props: { colSpan: 2 },
            };
          }
          return text;
        } else {
          if (["1", "3", "4", "5", "7"].includes(record.key)) {
            return {
              children: text,
              props: { colSpan: 2 },
            };
          }
          return text;
        }
      },
    },
    {
      title: "discountinput",
      dataIndex: "discountinput",
      key: "discountinput",
      width: 190,
      render: (text, record) => {
        if (isViewInvoice) {
          if (["1", "3", "4", "5", "6", "7"].includes(record.key)) {
            return { children: null, props: { colSpan: 0 } };
          }
        } else {
          if (["1", "3", "4", "5", "7"].includes(record.key)) {
            return { children: null, props: { colSpan: 0 } };
          }
        }
        if (record.key === "6") {
          if (isViewInvoice) {
            // If viewing, show nothing
            return { children: null, props: { colSpan: 0 } };
          }
          return (
            <Form.Item name="discount" style={{ margin: 0, width: "100%" }}>
              <Input.Group compact style={{ display: "flex" }}>
                <InputNumber
                  style={{ flex: 1 }}
                  min={0}
                  precision={2}
                  value={discount}
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                  onChange={(val) => {
                    const amount = val || 0;
                    if (discountType === 1 && amount > 100) {
                      setDiscount(100);
                    } else {
                      setDiscount(amount);
                    }
                    form.setFieldValue("discount", {
                      amount: discountType === 1 && amount > 100 ? 100 : amount,
                      isPercent: discountType === 1,
                    });
                    form.validateFields(["discount"]);
                  }}
                />
                <Select
                  value={discountType}
                  onChange={(val) => {
                    setDiscountType(val);
                    setDiscount(0);

                    form.setFieldValue("discount", {
                      amount: discount,
                      isPercent: val === 1,
                    });
                    form.validateFields(["discount"]);
                  }}
                  style={{ width: 70 }}
                >
                  <Select.Option value={0}>$</Select.Option>
                  <Select.Option value={1}>%</Select.Option>
                </Select>
              </Input.Group>
            </Form.Item>
          );
        }

        if (invoiceDetails?.taxId) {
          const tax = taxList.find((t) => t.id === invoiceDetails.taxId);
          if (tax) {
            return <p>{`${tax.name} ${tax.taxPercentage}%`}</p>;
          }
        }
        return text || "-";
      },
    },

    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      align: "right",
      width: 130,
      render: (text, record) => {
        // Read the form values dynamically inside render
        const invoiceAmount = Number(form.getFieldValue("invoiceAmount") || 0);
        const discountAmount = getDiscountAmount();

        const isDiscountInvalid = discountAmount > invoiceAmount;

        let isInvoiceInvalid;
        if (isAdditionalInvoice || isAdditionalItem) {
          isInvoiceInvalid = invoiceAmount > invoiceDetails?.grandTotal;
        } else {
          isInvoiceInvalid = invoiceAmount > dueAmount;
        }

        const isSaveDisabled = isInvoiceInvalid || isDiscountInvalid;

        setIsSaveDisabled(isSaveDisabled);

        if (record.key === "5") {
          return (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Form.Item
                name="invoiceAmount"
                style={{ margin: 0, width: "100%" }}
                //initialValue={invoiceDetails?.invoiceAmount ?? 0}
                rules={[
                  {
                    required: true,
                    message: intl.formatMessage({
                      id: "Invoice.error.Please EnterInvoicingAmount",
                    }),
                  },
                ]}
              >
                {isViewInvoice ? (
                  <p>${invoiceDetails?.invoicingAmount}</p>
                ) : (
                  <InputNumber
                    min={0}
                    precision={2}
                    style={{ width: "100%" }}
                    disabled={isAdditionalInvoice} // 🔒 disable when additional
                    // value={
                    //   isAdditionalInvoice
                    //     ? invoiceDetails?.grandTotal // reflect grand total
                    //     : form.getFieldValue("invoiceAmount")
                    // }
                    formatter={(value) =>
                      `$${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                    onChange={() => form.validateFields(["discount"])}
                  />
                )}
              </Form.Item>
              {isInvoiceInvalid && invoiceId == undefined && (
                <span style={{ color: "#ff4d4f", fontSize: 12 }}>
                  *{" "}
                  <FormattedMessage id="Invoice.InvoiceAmountCannotExceedDueAmount" />
                  ($
                  {isAdditionalInvoice
                    ? invoiceDetails?.grandTotal?.toFixed(2)
                    : dueAmount?.toFixed(2)}
                  )
                </span>
              )}
            </div>
          );
        }

        if (record.key === "6") {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >
              <span>
                $
                {discountAmount.toLocaleString("en-CA", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
              {isDiscountInvalid && (
                <span style={{ color: "#ff4d4f", fontSize: 12 }}>
                  *{" "}
                  <FormattedMessage id="Invoice.DiscountCannotExceedInvoicingAmount" />
                </span>
              )}
            </div>
          );
        }

        if (record.key === "7") {
          const invoiceAmount = Number(
            form.getFieldValue("invoiceAmount") || 0
          );
          const discountAmount = getDiscountAmount();
          const actualAmount = invoiceAmount - discountAmount;

          return (
            <span>
              $
              {actualAmount.toLocaleString("en-CA", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          );
        }

        return text;
      },
    },
  ];

  const data = [
    {
      key: "1",
      description: <FormattedMessage id="AddEstimate.SubTotal" />,
      value: `$${Number(
        invoiceId
          ? invoiceDetails?.subTotal ?? 0
          : invoiceDetails?.totalCost ?? 0
      ).toFixed(2)}`,
    },
    {
      key: "2",
      description: <FormattedMessage id="AddEstimate.TotalTax" />,
      value: `$${(invoiceDetails?.totalTax ?? 0).toFixed(2)}`,
    },
    {
      key: "3",
      description: <FormattedMessage id="AddEstimate.GrandTotal" />,
      value: `$${(invoiceDetails?.grandTotal ?? 0).toFixed(2)}`,
      className: "total-row",
    },
    {
      key: "4",
      description: <FormattedMessage id="Quote.DepositAmount" />,
      value: `$${(invoiceDetails?.depositAmount ?? 0).toFixed(2)}`,
    },
    {
      key: "5",
      description: <FormattedMessage id="Invoice.InvoicingAmount" />,
      value: "", // handled in render
    },
    {
      key: "6",
      description: <FormattedMessage id="Quote.Discount" />,
      discountinput: "", // handled in render
      value: "", // handled in render
    },
    {
      key: "7",
      description: <FormattedMessage id="Invoice.FinalInvoicingAmount" />,
      value: "", // handled in render
      className: "total-row",
    },
  ];

  const columns = [
    { title: "Product name", dataIndex: "productName" },
    { title: "Description", dataIndex: "description" },
    { title: "Quantity", dataIndex: "quantity" },
    { title: "Unit price", dataIndex: "unitPrice" },
    { title: "Discount", dataIndex: "discount" },
    { title: "Amount", dataIndex: "amount" },
  ];

  // const dataSource = [
  //   {
  //     key: 0,
  //     productName: "Panel",
  //     description: "Panel structure 5Kva",
  //     quantity: 1,
  //     unitPrice: "$1725.00",
  //     discount: "$0.00",
  //     amount: "$1725.00",
  //   },
  //   {
  //     key: 1,
  //     productName: "Panel Board",
  //     description: "this is for panel installation.",
  //     quantity: 2,
  //     unitPrice: "$110.00",
  //     discount: "$0.00",
  //     amount: "$220.00",
  //   },
  // ];

  const items = [
    {
      key: "1",
      label: (
        <Space direction="vertical">
          <div>
            <PhoneOutlined />
            &nbsp;&nbsp; 2143240000
          </div>
          <div>
            <MailOutlined />
            &nbsp;&nbsp; Nehra@gmail.com
          </div>
        </Space>
      ),
    },
  ];

  const handleUpsertInvoice = async () => {
    try {
      const values = await form.validateFields();

      const invoicingAmount = values.invoiceAmount;

      let DiscountAmount;
      if (discountType === 1) {
        DiscountAmount = (discount / 100) * invoicingAmount;
      } else {
        DiscountAmount = discount; // do not cap
      }

      const finalInvoceAmount = invoicingAmount - DiscountAmount;
      const obj = {
        Id: invoiceId ? invoiceDetails?.id : 0,
        ClientId: clientId,
        WorkOrderId: parseInt(workOrderId),
        InvoicingAmount: invoicingAmount,
        InvoiceDate: values.invoiceDate?.format("YYYY-MM-DD"),
        FinalInvoicingAmount: finalInvoceAmount,
        Notes: values.notes || "",
        DiscountType: discountType, // match backend casing
        TotalDiscount: discount ?? 0, // default to 0
        IsAdditionalItemInvoice: isAdditionalInvoice,
        ProjectId: projectId ? parseInt(projectId) : null,
      };

      return await dispatch(generateInvoiceAPI(obj)).then((res) => {
        handleRedirect();
        if (res) {
          return res;
        }
        return null;
      });
    } catch (error) {
      console.error("Validation failed:", error);
      return null;
    }
  };
  const handleEmailModalSave = async (emailData) => {
    setIsProcessing(true);
    try {
      const invoiceId = await handleUpsertInvoice();

      if (!invoiceId) {
        setIsProcessing(false);
        return;
      }

      const emailPayload = {
        InvoiceId: invoiceId,
        Subject: emailData.subject,
        Message: emailData.message,
        To: emailData.email.split(",").map((e) => e.trim()),
        Cc: emailData.cc ? emailData.cc.split(",").map((e) => e.trim()) : null,
        Attachments: null,
      };

      await dispatch(sendInvoiceEmailAPI(emailPayload));
      setIsEmailModalOpen(false);
      emailForm.resetFields();
    } catch (err) {
      console.error("Error:", err);
    }
    setIsProcessing(false);
    // handleRedirect();
  };
  const handleRedirect = () => {
    navigate(
      partnerId && clientId
        ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/${projectId}/projects/wo_details/${workOrderId}`
        : clientId
        ? `/${companyId}/${clientId}/client_details/wo_details/${workOrderId}`
        : `/${companyId}/${partnerId}/partner_client_details/wo_details/${workOrderId}`
    );
  };

  const payments = invoicePayments?.item1 || [];
  const paymentCount = payments.length;
  const latestPaymentDate =
    payments.length > 0 && payments[0].paymentDate
      ? (() => {
          const date = new Date(payments[0].paymentDate);
          return isNaN(date.getTime())
            ? null
            : date.toISOString().split("T")[0];
        })()
      : null;
  const handleViewPdf = async () => {
    let pdfWindow = window.open("", "_blank");
    if (!pdfWindow) {
      OpenNotificationWithIcon("error", "Common.Error", "", "Popup blocked!");
      return;
    }

    try {
      let pdfResponse;

      if (invoiceId) {
        pdfResponse = await dispatch(invoicePdfAPI(invoiceId));
      } else {
        const values = await form.validateFields();
        const invoiceInfo = {
          Id: invoiceId ? invoiceDetails?.id : 0,
          ClientId: clientId,
          WorkOrderId: parseInt(workOrderId),
          InvoicingAmount: values.invoiceAmount,
          InvoiceDate: values.invoiceDate.format("YYYY-MM-DD"),
          FinalInvoicingAmount: finalInvAmount,
          Notes: values.notes || "",
          discountType: discountType,
          TotalDiscount: discount ?? 0,
          IsAdditionalItemInvoice: isAdditionalInvoice,
        };
        pdfResponse = await dispatch(previewInvoiceAPI(invoiceInfo));
      }
      const base64 =
        pdfResponse?.pdfBase64?.value?.pdfBase64 || pdfResponse?.pdfBase64;
      const name = "Invoice_Preview";

      if (base64) {
        const pdfContent = `data:application/pdf;base64,${base64}`;
        pdfWindow.document.write(`
        <html>
          <head><title>${name}.pdf</title></head>
          <body style="margin:0">
            <iframe width="100%" height="100%" src="${pdfContent}" frameborder="0"></iframe>
          </body>
        </html>
      `);
        pdfWindow.document.close();
      } else {
        pdfWindow.close();
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "AddEstimate.FailedToGeneratePDFPreview"
        );
      }
    } catch (error) {
      pdfWindow.close();
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        error.message || "AddEstimate.UnableToPreviewPDF"
      );
    }
  };

  const handleDownloadPdf = async () => {
    try {
      let pdfResponse;

      if (invoiceId) {
        pdfResponse = await dispatch(invoicePdfAPI(invoiceId));
      } else {
        const values = await form.validateFields();
        const invoiceInfo = {
          Id: invoiceId ? invoiceDetails?.id : 0,
          ClientId: clientId,
          WorkOrderId: parseInt(workOrderId),
          InvoicingAmount: values.invoiceAmount,
          InvoiceDate: values.invoiceDate.format("YYYY-MM-DD"),
          FinalInvoicingAmount: finalInvAmount,
          Notes: values.notes || "",
          discountType: discountType,
          TotalDiscount: discount ?? 0,
          IsAdditionalItemInvoice: isAdditionalInvoice,
        };
        pdfResponse = await dispatch(previewInvoiceAPI(invoiceInfo));
      }

      const base64 =
        pdfResponse?.pdfBase64?.value?.pdfBase64 || pdfResponse?.pdfBase64;
      const name = `Invoice_${invoiceData?.invoiceNumber || "Download"}`;

      if (base64) {
        const link = document.createElement("a");
        link.href = `data:application/pdf;base64,${base64}`;
        link.download = `${name}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "AddEstimate.FailedToGeneratePDF"
        );
      }
    } catch (error) {
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        error.message || "AddEstimate.UnableToDownloadPDF"
      );
    }
  };

  useEffect(() => {
    if (invoiceId) {
      setInvoiceDetails(invoiceData);
      form.setFieldsValue({
        id: invoiceData?.id,
        notes: invoiceData?.notes,
        invoiceAmount: invoiceData?.invoicingAmount,
        discount: {
          amount: invoiceData?.totalDiscount,
          isPercent: invoiceData?.discountType === 1,
        },
      });
      setDiscountType(invoiceData?.discountType);
      setDiscount(invoiceData?.totalDiscount);
      setAdditionalItem(invoiceData?.isAdditionalItemInvoice);
    } else if (isAdditionalInvoice) {
      setInvoiceDetails(additionalItemWorkOrderDetails);
      form.setFieldsValue({
        invoiceAmount: additionalItemWorkOrderDetails?.grandTotal?.toFixed(2),
      });
    } else {
      setInvoiceDetails(workOrderDetails);
    }
  }, [workOrderDetails, invoiceData, additionalItemWorkOrderDetails]);

  useEffect(() => {
    console.log("Invoice Details Updated:", invoiceDetails);
  }, [invoiceDetails]);

  useEffect(() => {
    if (invoiceId == undefined && !isAdditionalInvoice) {
      const dataSource = invoiceDetails?.workOrderItems
        ?.filter((item) => !item.isAdditionalItem)
        .map((item) => ({
          key: item.id, // required by AntD Table
          productName: invoiceId
            ? item.productName
            : item.productServiceName || "",
          //productName: item.productName, // fallback
          description: item.description || "",
          quantity: item.quantity ?? 0,
          unitPrice: `$${(item.unitPrice ?? 0).toFixed(2)}`,
          discount:
            item.discount != null ? `$${item.discount?.toFixed(2)}` : "-",
          amount: `$${(item.amount ?? 0).toFixed(2)}`,
        }));

      setProductsList(dataSource);
    } else {
      const dataSource = invoiceDetails?.workOrderItems?.map((item) => ({
        key: item.id, // required by AntD Table
        // productName: invoiceId
        //   ? item.productName
        //   : item.productServiceName || "",
        productName: item.productName, // fallback
        description: item.description || "",
        quantity: item.quantity ?? 0,
        unitPrice: `$${(item.unitPrice ?? 0).toFixed(2)}`,
        discount: item.discount != null ? `$${item.discount.toFixed(2)}` : "-",
        amount: `$${(item.amount ?? 0).toFixed(2)}`,
      }));

      setProductsList(dataSource);
    }
  }, [invoiceDetails]);

  useEffect(() => {
    if (clientId && partnerId) {
      dispatch(GetClientByIdApi(clientId));
      dispatch(GetPartnerClientByIdApi(partnerId));
    } else if (clientId) {
      dispatch(GetClientByIdApi(clientId));
    } else if (partnerId) {
      dispatch(GetPartnerClientByIdApi(partnerId));
    }
  }, [clientId, partnerId]);

  useEffect(() => {
    dispatch(getCompanyListAPI(input));
    dispatch(GetWorkOrderByIdApi(workOrderId));
    // dispatch(getStatusAPI());
    dispatch(getAddressProvincesAPI());
    dispatch(getAddressCountriesAPI());
    dispatch(getSalesTaxAPI());
    if (isAdditionalInvoice) {
      dispatch(GetAdditionalitemsWorkOrderApi(workOrderId));
    }
  }, []);
  useEffect(() => {
    if (invoiceId) {
      dispatch(GetInvoiceByIdApi(invoiceId));
      dispatch(GetInvoicePaymentsByInvoiceIdApi(invoiceId));
    }
  }, [invoiceId]);

  return (
    <>
      <div className="medispamain" style={{ position: "relative" }}>
        <div className="main-area">
          <div className="title-part">
            <Row align="middle" justify="space-between" gutter={[16, 16]}>
              <Col xs={24} md={12} lg={12}>
                <h4>
                  {isViewInvoice ? (
                    <FormattedMessage id="Invoice.ViewInvoice" />
                  ) : invoiceId ? (
                    <FormattedMessage id="Invoice.EditInvoice" />
                  ) : (
                    <FormattedMessage id="Invoice.CreateInvoice" />
                  )}
                </h4>
                <p className="mt-5px">
                  {isViewInvoice ? null : (
                    <FormattedMessage id="Invoice.Message" />
                  )}
                </p>
              </Col>
              <Col
                xs={24}
                md={12}
                lg={12}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  textAlign: "right",
                }}
              >
                <Space>
                  <Col className="text-right">
                    <Breadcrumb
                      separator={<DoubleRightOutlined />}
                      items={[
                        {
                          title: partnerId ? (
                            <FormattedMessage id="PartnerClient.PartnerClientDetails" />
                          ) : (
                            <FormattedMessage id="ClientDetails.ClientDetails" />
                          ),
                          href:
                            partnerId && clientId
                              ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details`
                              : partnerId
                              ? `/${companyId}/${partnerId}/partner_client_details`
                              : `/${companyId}/${clientId}/client_details`,
                        },
                        {
                          title: (
                            <FormattedMessage id="WorkOrderDetails.WorkOrderDetails" />
                          ),
                          href:
                            partnerId && clientId
                              ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/${projectId}/projects/wo_details/${workOrderId}`
                              : partnerId
                              ? `/${companyId}/${partnerId}/partner_client_details/wo_details/${workOrderId}`
                              : `/${companyId}/${clientId}/client_details/wo_details/${workOrderId}`,
                        },
                        {
                          title: (
                            <FormattedMessage id="InvoiceDetails.InvoiceDetails" />
                          ),
                        },
                      ]}
                    />
                  </Col>
                </Space>
              </Col>
            </Row>
          </div>
          <Row gutter={[16, 16]} className="viewquote-new addestimate">
            <Col xs={24} md={24} lg={18}>
              <Form
                form={form}
                name="basic"
                layout="vertical"
                initialValues={formInitialvalues}
                autoComplete="off"
                size="large"
              >
                <Card variant="borderless">
                  <Form.Item name="id" hidden={true}></Form.Item>
                  <Row gutter={[16, 4]} align="top">
                    <Col span={24}>
                      <Typography.Text strong>
                        To:{" "}
                        <a href="">
                          {partnerId != null
                            ? invoiceDetails?.partnerClientName ||
                              workOrderDetails?.partnerName
                            : invoiceDetails?.clientName}
                        </a>
                      </Typography.Text>
                    </Col>
                    <Col xs={24} sm={5}>
                      <Typography.Text strong>
                        <FormattedMessage id="AddEstimate.BillingAddress" />
                      </Typography.Text>
                      <p>
                        {invoiceDetails?.companyAddress ? (
                          <span>
                            {renderAddress(invoiceDetails?.billingAddress)}
                          </span>
                        ) : null}
                      </p>
                    </Col>
                    <Col xs={24} sm={5}>
                      <>
                        <Typography.Text strong>
                          <FormattedMessage id="AddEstimate.ShippingAddress" />
                        </Typography.Text>
                        <p>
                          {invoiceDetails?.companyAddress ? (
                            <span>
                              {renderAddress(invoiceDetails?.companyAddress)}
                            </span>
                          ) : null}
                        </p>
                      </>
                    </Col>

                    {/* <Col xs={24} sm={3}>
                      <Typography.Text strong>
                        <FormattedMessage id="AddEstimate.ExpiryDate" />
                      </Typography.Text>
                      <p>2025-08-03</p>
                    </Col> */}

                    <Col xs={24} sm={5}>
                      {isViewInvoice ? (
                        <>
                          <Typography.Text strong>
                            <FormattedMessage id="AddEstimate.ExpiryDate" />
                          </Typography.Text>
                          <p>
                            {dayjs(invoiceDetails?.invoiceDate).format(
                              "YYYY-MM-DD"
                            )}
                          </p>
                        </>
                      ) : (
                        <Form.Item
                          label={
                            <FormattedMessage id="AddEstimate.EstimateDate" />
                          }
                          name="invoiceDate"
                          initialValue={dayjs()}
                          rules={[
                            {
                              required: true,
                              message: intl.formatMessage({
                                id: "AddEstimate.error.PleaseSelectTheEstimateDate",
                              }),
                            },
                          ]}
                        >
                          <DatePicker
                            className="w-100"
                            // disabledDate={(current) =>
                            //   current && current < dayjs().startOf("day")
                            // }
                            placeholder={intl.formatMessage({
                              id: "AddEstimate.Placeholder.SelectEstimateDate",
                            })}
                            //value={estimateDate}
                            //onChange={(date) => setEstimateDate(date)}
                            format="YYYY-MM-DD"
                          />
                        </Form.Item>
                      )}
                    </Col>

                    <Col xs={24} sm={5}>
                      <Typography.Text strong>WO #</Typography.Text>
                      <p>{invoiceDetails?.woNumber}</p>
                    </Col>
                  </Row>

                  <Table
                    bordered
                    dataSource={productsList}
                    pagination={false}
                    className="mt-20"
                    scroll={{
                      x: 900,
                    }}
                    summary={() => (
                      <Table.Summary.Row>
                        <Table.Summary.Cell colSpan={5} className="text-right">
                          <b>TOTAL</b>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell align="right">
                          <b>
                            $
                            {Number(
                              invoiceId
                                ? invoiceDetails?.subTotal ?? 0
                                : invoiceDetails?.totalCost ?? 0
                            ).toFixed(2)}
                          </b>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    )}
                    locale={{
                      emptyText: (
                        <Empty
                          image={Empty.PRESENTED_IMAGE_SIMPLE}
                          description={intl.formatMessage({
                            id: "NoData",
                          })}
                        />
                      ),
                    }}
                  >
                    <Column
                      title={<FormattedMessage id="ViewQuote.Item" />}
                      dataIndex="productName"
                      key="productName"
                    />
                    <Column
                      title={<FormattedMessage id="AddEstimate.Description" />}
                      dataIndex="description"
                      key="description"
                    />
                    <Column
                      title={<FormattedMessage id="ViewQuote.Quantity" />}
                      dataIndex="quantity"
                      key="quantity"
                      align="right"
                    />
                    <Column
                      title={<FormattedMessage id="Quote.UnitPrice" />}
                      dataIndex="unitPrice"
                      key="unitPrice"
                      align="right"
                    />
                    <Column
                      title={<FormattedMessage id="Quote.Discount" />}
                      dataIndex="discount"
                      key="discount"
                      align="right"
                    />
                    <Column
                      title={<FormattedMessage id="AddEstimate.Amount" />}
                      dataIndex="amount"
                      key="amount"
                      align="right"
                    />
                  </Table>

                  <Row gutter={[16, 16]} justify="end" className="mt-20">
                    <Col
                      xs={{ span: 24, order: 2 }}
                      sm={{ span: 24, order: 2 }}
                      md={{ span: 9, order: 1 }}
                      lg={{ span: 12, order: 1 }}
                    >
                      <Row gutter={16}>
                        <Col xs={24} sm={24}>
                          {isViewInvoice ? (
                            <>
                              <Typography.Text strong>
                                <FormattedMessage id="AddEstimate.Notes" />
                              </Typography.Text>
                              <p>{invoiceDetails?.notes}</p>
                            </>
                          ) : (
                            <Form.Item
                              label={
                                <FormattedMessage id="AddEstimate.Notes" />
                              }
                              name="notes"
                            >
                              <TextArea rows={7} maxLength={500} />
                            </Form.Item>
                          )}
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      xs={{ span: 24, order: 1 }}
                      sm={{ span: 24, order: 1 }}
                      md={{ span: 15, order: 2 }}
                      lg={{ span: 12, order: 2 }}
                    >
                      <Table
                        bordered
                        showHeader={false}
                        columns={totalColumns}
                        dataSource={data}
                        pagination={false}
                        scroll={{
                          x: 300,
                        }}
                        rowClassName={(record) =>
                          record.className === "total-row" ? "bold-text" : ""
                        }
                      />
                    </Col>

                    <Col
                      xs={{ span: 24, order: 3 }}
                      sm={{ span: 24, order: 3 }}
                    >
                      <Typography.Text strong>
                        <FormattedMessage id="AddEstimate.TermsAndConditions" />
                      </Typography.Text>
                      <div className="quote-quill">
                        {selectedCompany?.termsAndConditions &&
                          !isQuillContentEmpty(
                            selectedCompany.termsAndConditions
                          ) && (
                            <>
                              <div
                                className={`clamped-content ${
                                  expanded ? "expanded" : ""
                                }`}
                                dangerouslySetInnerHTML={{
                                  __html: selectedCompany.termsAndConditions,
                                }}
                              />
                              <span
                                className="toggle-link"
                                onClick={toggleExpanded}
                              >
                                {expanded ? "Read less" : "Read more"}
                              </span>
                            </>
                          )}
                      </div>
                    </Col>
                    {!isViewInvoice && (
                      <Col
                        xs={24}
                        sm={24}
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          flexWrap: "wrap",
                          gap: "10px",
                        }}
                      >
                        <Button
                          type="primary"
                          size="middle"
                          onClick={() => handleUpsertInvoice()}
                          disabled={isSaveDisabled}
                        >
                          <CheckCircleOutlined />
                          <FormattedMessage id="Quote.SaveAsDraft" />
                        </Button>

                        <Button
                          type="primary"
                          size="middle"
                          onClick={async () => {
                            try {
                              await form.validateFields();
                              setIsEmailModalOpen(true);
                            } catch {
                              // Do nothing
                            }
                          }}
                          disabled={isSaveDisabled}
                        >
                          <CheckCircleOutlined />
                          <FormattedMessage id="AddEstimate.SaveEstimateAndSendEmail" />
                        </Button>

                        <Button
                          danger
                          variant="outlined"
                          size="middle"
                          onClick={handleRedirect}
                        >
                          <CloseCircleOutlined />
                          <FormattedMessage id="AddEstimate.Cancel" />
                        </Button>
                      </Col>
                    )}
                  </Row>
                </Card>
              </Form>
            </Col>
            <Col xs={24} md={24} lg={6} className="custom-card-new">
              <Card variant="borderless">
                <div className="card-new-body">
                  <Row justify="center">
                    <Col>
                      <h5 style={{ textAlign: "center" }}>
                        {<FormattedMessage id="Invoice.WorkorderSummary" />}
                      </h5>
                    </Col>
                  </Row>
                  <Row
                    gutter={[16, 16]} // adds spacing between columns
                    justify="space-between"
                    align="middle"
                    className="mt-1"
                  >
                    <Col xs={12} sm={8} md={8} lg={7}>
                      <div className="text-center tex-sm-left">
                        <Text style={{ fontSize: 13, color: "#555" }}>
                          <FormattedMessage id="Invoice.AmountPaid" />
                        </Text>
                        <br />
                        <Text strong style={{ fontSize: 16 }}>
                          ${totalPaid?.toFixed(2)}
                        </Text>
                      </div>
                    </Col>

                    <Col xs={12} sm={8} md={8} lg={5}>
                      <div className="text-center tex-sm-left">
                        <Text style={{ fontSize: 13, color: "#555" }}>
                          <FormattedMessage id="Invoice.Deposit" />
                        </Text>
                        <br />
                        <Text strong style={{ fontSize: 16 }}>
                          ${workOrderDetails?.depositAmount?.toFixed(2) ?? 0}
                        </Text>
                      </div>
                    </Col>

                    <Col xs={24} sm={8} md={8} lg={12}>
                      <div className="text-right tex-sm-left">
                        <Text style={{ fontSize: 13, color: "#555" }}>
                          <FormattedMessage id="Invoice.OutstandingAmount" />
                        </Text>
                        <br />
                        <Text strong style={{ fontSize: 16, color: "#000" }}>
                          ${dueAmount?.toFixed(2)}
                        </Text>
                      </div>
                    </Col>

                    {/* {isViewInvoice && (
                      <Col span="24" className="mt-20">
                        <Button
                          type="primary"
                          block
                          onClick={() => setIsPaymentModalOpen(true)}
                        >
                          <FormattedMessage id="Invoice.RecordPayment" />
                        </Button>

                        <p className="mt-10">
                          {paymentCount > 0 ? (
                            <>
                              <a
                                onClick={() =>
                                  setIsPaymentRecordModelOpen(true)
                                }
                                style={{ cursor: "pointer" }}
                              >
                                {paymentCount} payment
                                {paymentCount > 1 ? "s" : ""}
                              </a>
                              {latestPaymentDate
                                ? ` on ${latestPaymentDate}`
                                : ""}
                            </>
                          ) : (
                            "No payments"
                          )}
                        </p>
                      </Col>
                    )} */}
                  </Row>
                </div>
              </Card>
              <Card className="mt-10" variant="borderless">
                <div className="card-new-body">
                  <Row gutter={[8]} className="viewinvoicebuttons">
                    <Col span={12}>
                      <Button
                        color="default"
                        variant="link"
                        onClick={handleViewPdf}
                      >
                        <EyeFilled />
                        <FormattedMessage id="ViewQuote.Preview" />
                      </Button>
                    </Col>
                    <Col span={12}>
                      <Button
                        color="default"
                        variant="link"
                        onClick={handleDownloadPdf}
                      >
                        <DownloadOutlined />
                        <FormattedMessage id="Invoice.Download" />
                      </Button>
                    </Col>
                    {isViewInvoice && (
                      <>
                        <Col span={12}>
                          <Button
                            color="default"
                            variant="link"
                            onClick={() => setIsPaymentModalOpen(true)}
                          >
                            <DollarOutlined />
                            <FormattedMessage id="Invoice.RecordPayment" />
                          </Button>
                        </Col>
                        <Col span={12}>
                          <Button
                            color="default"
                            variant="link"
                            onClick={() => setIsPaymentRecordModelOpen(true)}
                          >
                            <WalletOutlined />
                            <FormattedMessage id="Invoice.InvoicePayments" />
                          </Button>
                        </Col>
                      </>
                    )}
                  </Row>
                </div>
              </Card>
              {/* <Card className="mt-10">
                <p>A detailed breakdown of payments and refunds.</p>
                <Table
                  className="mt-10"
                  columns={columns1}
                  dataSource={data1}
                  pagination={false}
                  bordered
                />
              </Card> */}
            </Col>
          </Row>

          {isPaymentModalOpen && (
            <RecordPayment
              open={isPaymentModalOpen}
              close={() => setIsPaymentModalOpen(false)}
            />
          )}

          <Modal
            title={<FormattedMessage id="Invoice.PaymentsandAllocations" />}
            open={isPaymentRecordModelOpen}
            onCancel={() => setIsPaymentRecordModelOpen(false)}
            footer={null}
            width={900}
          >
            <p>
              <FormattedMessage id="Invoice.Adetailedbreakdown" />
            </p>
            <Table
              className="mt-10"
              columns={columns2}
              dataSource={data1}
              pagination={false}
              bordered
              scroll={{ x: 600 }}
              summary={() => (
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={3}>
                    <FormattedMessage id="Invoice.Total" />
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={3}>
                    {InvoicePaymentsTotal}
                  </Table.Summary.Cell>
                  {/* <Table.Summary.Cell index={4}>0.00</Table.Summary.Cell> */}
                  {/* <Table.Summary.Cell index={5}>2000.00</Table.Summary.Cell> */}
                  <Table.Summary.Cell index={5}></Table.Summary.Cell>
                </Table.Summary.Row>
              )}
            />
            {/* <Row justify="end">
              <Col sm={24} md={12} lg={6}>
                <div style={{ marginTop: 20 }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 10,
                    }}
                  >
                    <strong>Total Invoice</strong>
                    <span>
                      <strong>$2490.00</strong>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 10,
                    }}
                  >
                    <strong>Paid Total</strong>
                    <span>
                      <strong>$2000.00</strong>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 10,
                    }}
                  >
                    <strong>Refund Total</strong>
                    <span>
                      <strong>$2000.00</strong>
                    </span>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <strong>Outstanding</strong>
                    <span>
                      <strong>$490.00</strong>
                    </span>
                  </div>
                </div>
              </Col>
            </Row> */}
          </Modal>
        </div>
      </div>
      <SendEmailModal
        type="invoice"
        isOpen={isEmailModalOpen}
        confirmLoading={isProcessing}
        onCancel={() => {
          setIsEmailModalOpen(false);
          emailForm.resetFields();
        }}
        onSend={() => {
          emailForm.validateFields().then((values) => {
            handleEmailModalSave(values);
          });
        }}
        form={emailForm}
      />
    </>
  );
}

export default CreateInvoice;
